// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChannelNoticeController from "./channel_notice_controller"
import BackToTopController from "./back_to_top_controller"
import MapController from "./map_controller"
import PaymentToggleController from "./payment_toggle_controller"
import NavController from "./nav_controller"
application.register("channel-notice", ChannelNoticeController)
application.register("back-to-top", BackToTopController)
application.register("map", MapController)
application.register("payment-toggle", PaymentToggleController)
application.register("nav", NavController)

import CapacityToggleController from "./capacity_toggle_controller"
application.register("capacity-toggle", CapacityToggleController)

import RecurrenceController from "./recurrence_controller"
application.register("recurrence", RecurrenceController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import FormConsentController from "./form_consent_controller"
application.register("form-consent", FormConsentController)

import HeardAboutUsController from "./heard_about_us_controller"
application.register("heard-about-us", HeardAboutUsController)

import CheckinController from "./checkin_controller"
application.register("checkin", CheckinController)

import MemberLookupController from "./member_lookup_controller"
application.register("member-lookup", MemberLookupController)

import TestimonialFormatController from "./testimonial_format_controller"
application.register("testimonial-format", TestimonialFormatController)

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FilterDisclosureController from "./filter_disclosure_controller"
application.register("filter-disclosure", FilterDisclosureController)

import SplideController from "./splide_controller"
application.register("splide", SplideController)

import EventListController from "./event_list_controller"
application.register("event-list", EventListController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import SocialGraphController from "./social_graph_controller"
application.register("social-graph", SocialGraphController)

import HeroVideoController from "./hero_video_controller"
application.register("hero-video", HeroVideoController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ImportCountController from "./import_count_controller"
application.register("import-count", ImportCountController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import StickyHeaderController from "./sticky_header_controller"
application.register("sticky-header", StickyHeaderController)

import ScrollEdgeController from "./scroll_edge_controller"
application.register("scroll-edge", ScrollEdgeController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import MemberImportController from "./member_import_controller"
application.register("member-import", MemberImportController)

import ZoneController from "./zone_controller"
application.register("zone", ZoneController)

import AreaTownsController from "./area_towns_controller"
application.register("area-towns", AreaTownsController)

import SelectionController from "./selection_controller"
application.register("selection", SelectionController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import BroadcastPreviewController from "./broadcast_preview_controller"
application.register("broadcast-preview", BroadcastPreviewController)

import StickyHeadController from "./sticky_head_controller"
application.register("sticky-head", StickyHeadController)

import MemberFilterController from "./member_filter_controller"
application.register("member-filter", MemberFilterController)
